<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag
        size="small"
        :type="getStatusName(scope.row.status).tag"
      >
        {{ getStatusName(scope.row.status).label }}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
  methods: {
    getStatusName(status) {
      switch (status) {
        case 'inactive':
          return {
            label: 'Inaktív',
            tag: 'danger',
          };
        case 'active':
          return {
            label: 'Aktív',
            tag: 'success',
          };
        case 'run-out':
          return {
            label: 'Kifutó',
            tag: 'primary',
          };
        case 'run-out-inactive':
          return {
            label: 'Kifutó és inaktív',
            tag: 'warning',
          };
        case 'hidden':
          return {
            label: 'Láthatatlan',
            tag: 'info',
          };
      }
    },
  },
};
</script>
